export enum FeatureCode {
  TextA = 'textA',

  /**
   * 电池容量
   */
  BatteryVolume = 'F00019',

  /**
   * 电池购买方式
   */
  BatteryPurchaseType = 'F00029',

  /**
   * 外观颜色
   */
  Color = 'F00002',

  /**
   * 轮圈
   */
  Wheel = 'F00003',

  /**
   * 卡钳
   */
  Calipers = 'F00024',

  /**
   * 外饰套件 Moon 主题
   */
  Moon = 'F00030',

  /**
   * 内饰主题
   */
  InteriorTheme = 'F00004',

  /**
   * 内饰材质
   */
  InteriorMaterial = 'F000024',

  /**
   * 钥匙
   */
  Key = 'F00020',

  /**
   * 第二把钥匙
   */
  KeySecond = 'F00021',
}

export enum OptionCode {
  TextB = 'textB',
}

/**
 * 一级类目 Code 枚举
 */
export enum CategoryCode {
  /**
   * 版本电池
   */
  VersionBattery = 'version_battery',

  /**
   * 外观
   */
  Exterior = 'exterior',

  /**
   * 座舱
   */
  Cockpit = 'cockpit',

  /**
   * 选装
   */
  Optional = 'optional',

  /**
   * NAD
   */
  NAD = 'nad',

  /**
   * 核心标配
   */
  Additional = 'additional',
}

/**
 * 二级类目 Code 枚举
 */
export enum SubCategoryCode {
  /**
   * 版本（版本电池）
   */
  Version = 'version',

  /**
   * 电池（版本电池）
   */
  Battery = 'battery',

  /**
   * 颜色（外观）
   */
  Color = 'color',

  /**
   * 轮圈（外观）
   */
  Wheel = 'wheel',

  /**
   * 定制（外观）
   */
  ExteriorCustom = 'exterior_custom',

  /**
   * 内饰（座舱）
   */
  Interior = 'interior',

  /**
   * 钥匙（座舱）
   */
  Key = 'key',

  /**
   * 定制（座舱）
   */
  CockpitCustom = 'cockpit_custom',

  /**
   * 选装（选装）
   */
  SubOptional = 'sub_optional',

  /**
   * 核心标配
   */
  SubAdditional = 'sub_additional',
}

export interface DesignerPlanItem {
  /**
   * 名称
   */
  name: string

  /**
   * 描述
   */
  desc: string

  /**
   * 图片
   */
  img_url: string

  /**
   * 小图
   */
  small_img_url: string

  /**
   * 单项优惠标签 img
   */
  discount_icon_v2?: string
  /**
   * 单项优惠标签 宽高比
   */
  discount_icon_v2_ratio?: number

  /**
   * 设计师方案 option
   */
  option_list: {
    code: string

    /**
     * 名称
     */
    name: string

    /**
     * 配置类型code
     */
    feature_code: string

    /**
     * feature类型
     */
    feature_type: string

    /**
     * 价格
     */
    price: number

    /**
     * 划线价
     */
    origin_price: number
  }[],
  /**
   * 单项优惠标签 img 替换原先的 discount_icon
   */
  icon_bean?: {
    icon?: string
    /**
     * 优惠包icon 宽高比
     */
    icon_ratio?: string,
     /**
     * 优惠包icon 类型 无标签0；营销标签1；糖豆标签2；优惠标签3；惠标4
     */
    icon_type?: string,
  },

  /**
   * 优惠包icon 列表
   */
  icon_list?: {
    /**
     * 营销标签 img link
     */
    icon?: string
    /**
     * 营销标签 img 的宽高比
     */
    icon_ratio?: string
    /**
     * 营销标签 img 类型 无标签0；营销标签1；糖豆标签2；优惠标签3；惠标4
     */
    icon_type?:string
  }[],
}

/**
 * 二级类目 版本 电池 颜色 轮圈 定制 内饰 钥匙
 */
export interface SubCategoryItem {
  /**
   * 仅供参考文案
   */
  name: string

  /**
   * 二级类目code
   */
  code: SubCategoryCode

  /**
   * 仅供参考文案
   */
  reference_desc: string

  /**
   * 版本/配置list
   */
  feature_list: FeatureItem[]

  /**
   * 设计师方案文案
   */
  designer_plan_desc: string

  /**
   * 设计师方案icon
   */
  designer_plan_icon: string

  /**
   * 设计师方案 list
   */
  designer_plan_list: DesignerPlanItem[]
}

/**
 * 配置分类枚举
 */
export enum FeatureType {
  /**
   * 版本（版本）
   */
  Version = 'version',

  /**
   * 电池容量（电池）
   */
  BatteryVolume = 'battery_volume',

  /**
   * 购买方式（电池）
   */
  BatteryPurchaseType = 'battery_purchase_type',

  /**
   * 颜色（外观）
   */
  ExteriorColor = 'exterior_color',

  /**
   * 轮圈（外观）
   */
  ExteriorWheel = 'exterior_wheel',

  /**
   * 定制（外观）
   */
  ExteriorCustom = 'exterior_custom',

  /**
   * 内饰颜色（座舱）
   */
  CockpitInteriorColor = 'cockpit_interior_color',

  /**
   * 内饰材质（座舱）
   */
  CockpitInteriorMaterial = 'cockpit_interior_material',

  /**
   * 钥匙（座舱）
   */
  CockpitKey = 'cockpit_key',

  /**
   * 定制（座舱）
   */
  CockpitCustom = 'cockpit_custom',

  /**
   * 选装（选装）
   */
  SubOptional = 'sub_optional',

  /**
   * 核心标配
   */
  SubAdditional = 'sub_additional',
}

/**
 * 配置信息
 */
export interface FeatureItem {
  /**
   * 配置分类名称
   */
  name: string

  feature_code: FeatureCode

  /**
   * feature类型
   */
  feature_type: FeatureType

  /**
   * 选项类型: 0 单选，1 多选
   */
  multi_choice_type: 0 | 1

  /**
   * 去了解文案（电池购买方式）
   */
  detail_desc: string

  /**
   * 大段说明h5链接（选装页），去了解链接url（电池购买方式）
   */
  detail_desc_url: string

  /**
   * 选项详情样式类型
   */
  option_detail_style_type: 'only_desc_old' | 'support_material'

  /**
   * 配置 code 列表
   */
  option_list?: string[]
  /**
   * 年款列表
   */
  year_list?: {
    year: string
    year_name: string
    selected: number // 是否选中，0 不选中，1 选中
    default_generation_code: string
    generation_code_list: string[]
  }[]
}

/**
 * 一级类目，版本 电池 外观 座舱 选装
 */
export interface CategoryItem {
  /**
   * 类目名称
   */
  name: string

  /**
   * 一级类目code
   */
  code: CategoryCode

  /**
   * 仅供参考文案
   */
  reference_desc: string

  /**
   * 总价值文案
   */
  total_price: string

  /**
   * 二级类目列表
   */
  sub_category_list: SubCategoryItem[]
}

export interface CarTypeChangeCouponToast {
  title: string
  content: string
  car_types: string[]
}

/**
 * 车辆版本 Map
 */
export interface GenerationItem {
  /**
   * 多张图片（主图）
   */
  img_url_list: string[]

  /**
   * 版本 code
   */
  code: string

  /**
   * 配置类型code
   */
  feature_code: string

  /**
   * feature 类型
   */
  feature_type?: FeatureType | string

  /**
   * 名称
   */
  name: string

  /**
   * 描述
   */
  desc: string

  /**
   * 价格
   */
  price: number

  /**
   * 价格后缀
   */
  price_suffix_desc?: string

  /**
   * 版本描述信息（版本页）
   */
  desc_list: string[]

  /**
   * 交付日期文案（版本页）
   */
  delivery_date_desc: string

  /**
   * 预售活动编号
   */
  pre_sale_event_no: string

  /**
   * 是否可选，0 可选，1 不可选（版本页）
   */
  can_select: 0 | 1

  /**
   * 是否选中，0 不选中，1 选中
   */
  selected: 0 | 1

  /** -------- 业务自己添加，非接口字段 -------- */

  /**
   * 选项类型: 0 单选，1 多选
   */
  multi_choice_type: FeatureItem['multi_choice_type']
  /**
   * 限售或者售罄 图片 暂定
   */
  limit_img_url: string
  /**
   * toast 售罄toast提示
   */
  toast?: string
  /**
   * icon 车款icon提示
   */
  icon?: string
  /**
   * 变更车型/车款可能会导致购车优惠卡券失效，敬请留意。
   */
  car_type_change_coupon_toast?: CarTypeChangeCouponToast
  /**
   * 版本页车款分组名称
   */
  group_name?: string
  /**
   * 版本页详情链接
   */
  detail_desc_url?: string
  /**
   * 版本页主视觉配置
   */
  version_page_background?: VersionPageBackground
}

export interface GenerationMap {
  [key: string]: GenerationItem
}

export interface VersionPageBackground {
  img_url: string
  wide_img_url: string
  img_ratio: number
  color: string
}

export interface VersionPageGenerationConfig {
  group_type: string
  group_name: string
  detail_desc_url: string
  version_page_background: VersionPageBackground
}

export interface VersionPageInfoItem {
  default_generation_index: number
  generation_code_list: string[]
}

export interface VersionPageInfo {
  bottom_button_name: string
  default_version_index: number
  version_list: VersionPageInfoItem[]
  version_background: {
    color: string
    alpha: number
    blur: number
  }
}

export type OptionItem = Partial<{
  /**
   * 多张图片（主图）
   */
  img_url_list: string[]

  /**
   * 小图，颜色，轮圈，内饰等
   */
  small_img_url: string

  /**
   * 配置项 code
   */
  code: string

  /**
   * 配置类型code
   */
  feature_code: string

  /**
   * feature类型，枚举见备注
   */
  feature_type: FeatureType

  /**
   * 名称
   */
  name: string

  /**
   * 描述
   */
  desc: string

  /**
   * 价格
   */
  price: number

  /**
   * 文案
   */
  detail_desc: string

  /**
   * 大段说明h5链接（选装页），去了解链接url（电池购买方式）
   */
  detail_desc_url: string

  /**
   * 提示说明文案
   */
  tip_desc: string

  /**
   * 提示说明标题
   */
  tip_title: string

  /**
   * 是否可选，0 可选，1 不可选（版本页）
   */
  can_select: 0 | 1

  /**
   * 是否选中，0 不选中，1 选中
   */
  selected: 0 | 1

  /**
   * 绑定配置
   */
  bind_list: BindItem[]

  /**
   * 互斥配置
   */
  mutex_list: MutexItem[]
  /**
   * 关联配置
   */
  relation_list: RelationItem[]

  /**
   * 价格旁边的文案，预计9月开启选配
   */
  price_desc: string

  /** -------- 业务自己添加，非接口字段 -------- */

  /**
   * 选项类型: 0 单选，1 多选
   */
  multi_choice_type: FeatureItem['multi_choice_type']
  /**
   * 是否置灰（聚合字段，业务侧计算）
   */
  disabled?: boolean
  /**
   * 优惠包icon
   */
  discount_icon?: string
  /**
   * 优惠包tips
   */
  discount_tip?: string
  /**
   * 优惠包icon
   */
  discount_tip_icon?: string
  /**
   * 优惠包icon 宽高比
   */
  discount_tip_icon_ratio?: number
  /**
   * 划线价
   */
  origin_price?: number
  /**
   * 单项优惠标签 img
   */
  discount_icon_v2?: string
  /**
   * 单项优惠标签 宽高比
   */
  discount_icon_v2_ratio?: number,
  /**
   * package_price_desc
   */
  package_price_desc?: string,
  /**
   * 单项优惠标签 img 替换原先的 discount_icon
   */
  icon_bean?: {
    icon?: string
    /**
     * 优惠包icon 宽高比
     */
    icon_ratio?: string,
     /**
     * 优惠包icon 类型 无标签0；营销标签1；糖豆标签2；优惠标签3；惠标4
     */
    icon_type?: string,
  },
  /**
   * 优惠包icon 类型 无标签0；营销标签1；糖豆标签2；优惠标签3；惠标4
   */
  icon_type?: string,
  /**
   * 优惠包icon 列表
   */
  icon_list?: {
    /**
     * 营销标签 img link
     */
    icon?: string
    /**
     * 营销标签 img 的宽高比
     */
    icon_ratio?: string
    /**
     * 营销标签 img 类型 无标签0；营销标签1；糖豆标签2；优惠标签3；惠标4
     */
    icon_type?:string
  }[],
  /**
   * 选项详情样式类型
   */
  option_detail_style_type: string
}>

/**
 * 绑定关系结构
 */
export interface BindItem {
  /**
   * option code
   */
  code: string

  /**
   * 配置类型code
   */
  feature_code: string

  /**
   * feature类型，枚举见备注
   */
  feature_type: FeatureType

  /**
   * 提示文案
   */
  toast_desc: string
}

/**
 * 互斥关系结构
 */
export interface MutexItem {
  /**
   * option code
   */
  code: string

  /**
   * 配置类型code
   */
  feature_code: string

  /**
   * feature类型，枚举见备注
   */
  feature_type: FeatureType

  /**
   * 提示文案
   */
  toast_desc: string
}
/**
 * 关联关系结构
 */
export interface RelationItem {
  /**
   * option code
   */
  code: string

  /**
   * 配置类型code
   */
  feature_code: string

  /**
   * feature类型，枚举见备注
   */
  feature_type: FeatureType

  /**
   * 提示文案
   */
  toast_desc: string
}

export interface OptionMap {
  [key: string]: OptionItem
}

/** package_price_list 单项上的营销图标（与 OptionItem.icon_list 语义一致） */
export interface PackagePriceIconItem {
  icon?: string
  icon_ratio?: string | number
  icon_type?: string | number
}

export interface PackagePriceItem {
  option_code?: string
  code?: string
  price?: number
  package_price_desc?: string
  icon_list?: PackagePriceIconItem[]
  // detail_desc_url?: string
}

export type OptionCombineItem = Partial<{
  /**
   * 描述
   */
  desc: string

  /**
   * 名称
   */
  name: string

  /**
   * 价格
   */
  price: number

  /**
   * 小图，颜色，轮圈，内饰等
   */
  small_img_url: string

  /**
   * 里程（电池页）
   */
  mileage: string

  /**
   * 里程单位（电池页）
   */
  mileage_unit: string

  /**
   * 里程描述（电池页）
   */
  mileage_desc: string

  /**
   * 提示说明文案
   */
  tip_desc: string

  /**
   * 提示说明标题
   */
  tip_title: string

  /**
   * H5 大段说明文案
   */
  detail_desc_url: string

  /**
   * 价格旁边的文案，预计9月开启选配
   */
  price_desc: string
  /**
   * 优惠包icon
   */
  discount_icon?: string
  /**
   * 优惠包tips
   */
  discount_tip?: string
  /**
   * 优惠包icon
   */
  discount_tip_icon?: string
  /**
   * 优惠包icon 宽高比
   */
  discount_tip_icon_ratio?: number
  /**
   * 划线价
   */
  origin_price?: number
  /**
   * 单项优惠标签 img
   */
  discount_icon_v2?: string
  /**
   * 单项优惠标签 宽高比
   */
  discount_icon_v2_ratio?: string
  /**
   * 提示文案
   */
  img_float_tip?: string

  /**
   * combine标签背景
   */
  desc_background_img?: string
  /**
   * package_price_desc
   */
  package_price_desc?: string,
  /**
   * 优惠包icon 列表
   */
  icon_list?: {
    /**
     * 营销标签 img link
     */
    icon?: string
    /**
     * 营销标签 img 的宽高比
     */
    icon_ratio?: string
    /**
     * 营销标签 img 类型 无标签0；营销标签1；糖豆标签2；优惠标签3；惠标4
     */
    icon_type?:string
  }[],
}>

export interface OptionCombineMap {
  [key: string]: OptionCombineItem
}

export interface FeatureReq {
  /**
   * 车款code，例如：ES8001
   */
  generation_code?: string

  /**
   * 订单号
   */
  order_no?: string

  /**
   * 车型code，例如：ES8
   */
  model_code: string

  /**
   * 是否需要查询版本，0 需要，1 不需要，默认不需要
   */
  need_generation: 0 | 1

  /**
   * 心愿单号
   */
  conf_no?: string

  /**
   * 1 老ES8，2 新ES8，其他为空
   */
  new_version?: 1 | 2
}

export interface VersionDetailInfo {
  /**
   * 入口右侧按钮文案
   */
  button: string
  /**
   * 入口主文案
   */
  name: string
  /**
   * 版本详情弹窗标题
   */
  title: string
}
export interface BatteryIntro {
  background_img_url: string
  desc: string
  icon_url: string
  link: string
}
export interface BatteryVolumeHideListItem {
  select_option_code: string
  hide_option_code: string
}
export enum rightTypeEnum {
  NORMAL = 'normal',
  GRADIENT = 'gradient',
}
export interface topTip {
  type: rightTypeEnum
  icon: string
  desc: string
  link: string
  desc_color: string
  background_color: Array<string>
  style?: string // 样式类型 large：大样式，small：小样式
  show_page_list?: SubCategoryCode[] // 展示页面列表
}

export interface FeatureRes {
  data: {
    category_list: CategoryItem[]
    generation_map: GenerationMap
    version_page_info?: VersionPageInfo
    version_page_change_generation_toast?: string
    generation_code: string
    option_map: OptionMap
    option_combine_map: OptionCombineMap
    package_price_list?: PackagePriceItem[]
    model_code: string
    model_name: string
    version_detail?: VersionDetailInfo
    battery_intro?: BatteryIntro
    model_logo_url?: string
    //todo mock暂定
    top_tip: topTip
    // right_tip?: rightTip
    hide_battery_volume_option_list?: BatteryVolumeHideListItem[]
    non_selectable_option_list?: string[]
    // 埋点用
    front_metric?: object
  }
}
